module.exports = __webpack_public_path__ + "static/media/beta_radar.4a63c220.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/order/beta_radar.png
// module id = 1824
// module chunks = 0